import React from 'react';

export const UnassignIcon = () => (
  <svg
    width="12"
    height="12"
    viewBox="0 0 12 12"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M8 10.5V9.5C8 8.96957 7.78929 8.46086 7.41421 8.08579C7.03914 7.71071 6.53043 7.5 6 7.5H3C2.46957 7.5 1.96086 7.71071 1.58579 8.08579C1.21071 8.46086 1 8.96957 1 9.5V10.5"
      stroke="#FB2C36"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M4.5 5.5C5.60457 5.5 6.5 4.60457 6.5 3.5C6.5 2.39543 5.60457 1.5 4.5 1.5C3.39543 1.5 2.5 2.39543 2.5 3.5C2.5 4.60457 3.39543 5.5 4.5 5.5Z"
      stroke="#FB2C36"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path d="M11 5.5H8" stroke="#FB2C36" strokeLinecap="round" strokeLinejoin="round" />
  </svg>
);
